import {
    mapProductsForList,
    mapProductsForOne,
    mapStatesForList,
    mapStatesForOne,
    mapSalesChannelsForList,
    mapSalesChannelsForOne,
} from './common';

function mapGetOneCollateralTemplateData(responseData) {
    return {
        ...responseData,
        ...mapProductsForOne(responseData),
        ...mapStatesForOne(responseData),
        ...mapSalesChannelsForOne(responseData),
    };
}

function mapGetListCollateralTemplatesData(responseData) {
    return responseData.map((data) => ({
        ...data,
        ...mapProductsForList(data),
        ...mapStatesForList(data),
        ...mapSalesChannelsForList(data),
    }));
}

export { mapGetOneCollateralTemplateData, mapGetListCollateralTemplatesData };
